import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listItems } from '../../actions/Items/actions';
import SelectWrapper from './SelectWrapper';

const ItemSelect = ({
    name,
    value,
    defaultValue = null,
    onChange = () => { },
    onBlur = () => { },
    ...rest
}) => {
    const dispatch = useDispatch();
    const items = useSelector(state => state.items.items);

    useEffect(() => {
        dispatch(listItems({ limit: 500, offset: 0, search: null }));
    }, [dispatch]);

    const rawItems = useMemo(() => items?.results || [], [items]);

    const options = useMemo(() =>
        rawItems.map(item => ({
            label: `${item.name}: ${item.item_number}`,
            value: item.item_number
        })), [rawItems]);

    const fromValueToOption = val => {
        if (!items || !value) return null;

        // If value is already an object from react-select
        if (typeof value === 'object' && value.label && value.value) {
            return value;
        }

        const found = rawItems.find(item => item.item_number === val);
        return found ? {
            label: `${found.name}: ${found.item_number}`,
            value: found.item_number
        } :  {
            label: `Unknown item: ${value}`,
            value: value,
            isDisabled: true
          };
    };

    const handleChange = selected => {
        onChange(name, selected);
    };

    const handleBlur = () => {
        onBlur(name, true);
    };

    return (
        <SelectWrapper
            name={name}
            options={options}
            value={fromValueToOption(value)}
            defaultValue={fromValueToOption(defaultValue)}
            onChange={handleChange}
            onBlur={handleBlur}
            isClearable
            isSearchable
            {...rest}
        />
    );
};

export default ItemSelect;
